import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

export const textColor = "#000000de" //"#525f7f"
export const hoverCode="#88f29d"
export const btnTextColor = "#fff"
export const btnHoverColor = "linear-gradient(to right, rgb(144, 162, 210), rgb(158, 223, 131))";

export const green = {
  50: '#cce7c9',
  100: '#acd8a7',
  200: '#8bca84',
  300: '#72bf6a',
  400: '#5bb450',
  500: '#52a447',
  600: '#46923c',
  700: '#3b8132',
  800: '#276221',
};

export const blue = {
  0: '#688aad',
  25: '#3fa9f5',
  50: '#1877F2',
  100: '#3891d6',
  150: '#007577',
  200: '#3179b8',
  300: '#2a6199',
  400: '#22487a',
  500: '#1b305b',
  600: '#08335e',
  700: '#14183d',
  800: '#03213d',
  900: '#002abe'
};

export const grey = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
}

export const primary = {
  lighter: '#D0ECFE',
  light: '#73BAFB',
  main: '#1877F2',
  dark: '#0C44AE',
  darker: '#042174',
  contrastText: '#FFFFFF',
};

export const secondary = {
  lighter: '#05aa7324',
  light: '#C684FF',
  main: '#8E33FF',
  blue: '#22487a',
  darker: '#27097A',
  contrastText: '#FFFFFF',
  green:'#00a67d'
};

export const info = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#C8FAD6',
  light: '#5BE49B',
  main: '#00A76F',
  dark: '#007867',
  darker: '#004B50',
  contrastText: '#FFFFFF',
};

export const warning = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: grey[800],
};

export const error = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
  lightGrey: '#F0F0F0'
};

export const action = {
  hover: alpha(hoverCode, 0.9),
  selected: alpha(textColor, 0.16),
  disabled: alpha(textColor, 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.5,
  disabledOpacity: 0.48,
};

export const dashboardAction = {
  hover: alpha(hoverCode, 0.9),
  selected: blue[700],
  disabled: alpha(blue[500], 0.8),
  disabledBackground: alpha(blue[500], 0.24),
  focus: alpha(blue[500], 0.24),
  hoverOpacity: 0.5,
  disabledOpacity: 0.48,
}

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  blue,
  green,
  common,
  divider: alpha(grey[500], 0.2),
  action,
  dashboardAction
};

// ----------------------------------------------------------------------

export function palette() {
  return {
    ...base,
    mode: 'light',
    text: {
      primary: common.lightGrey,
      secondary: green[600],
      disabled: textColor,
    },
    background: {
      paper: '#FFFFFF',
      default: '#FFFFFF',
      neutral: green[200],
    },
    action: {
      ...base.action,
      ...base.dashboardAction,
      active: green[600],
    },
  };
}
